import _result from 'lodash/result';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import _values from 'lodash/values';
import _has from 'lodash/has';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OcpWidget from '../../common/ocpCardPrompt/OcpWidget';

// Actions
import {
  selectTopicL1, selectTopicL2, selectTopicL3, selectTopicReset, selectTopic,
} from '../actions/action-select-topic';
import { postChatBotEligibility, postChatBotEligibleFalse } from '../actions/action-postchatbot-eligibility';

// Components
// import TopicBreadCrumb from '../components/TopicBreadCrumb';
import TopicList from '../components/TopicList';
import NavBackArrow from '../components/NavBackArrow';
import IntentTopicBox from './IntentTopicBox';
import ColGrid from '../components/ColGrid';

// Helper
import l10n from '../../lib/reactPPl10nHelper';
import Page from '../../lib/page';
import { trackLink } from '../../lib/analytics-helper';
import { TOPICTREE, TOPICSELECT, REF_SELECT_RESULT } from '../constants/PropTypesShapes';
import { fetchPhoneNumber } from '../actions/action-call-us';
import { validateAMFlag } from '../../lib/globalHelper';

// const isMobileLayout = Page.isMobileLayout();
const topicLabel = {
  heading: l10n.getContent('smarthelp/channelSelection.topicSelections.browser.header'),
  contactHeader: l10n.getContent('smarthelp/channelSelection.contactUs.header'),
  commonIssue: l10n.getContent('smarthelp/channelSelection.topicSelections.navigation.header.layer1'),
  selectHeader: l10n.getContent('smarthelp/channelSelection.topicSelections.searchTopics.header'),
};

class TopicTreeBrowser extends Component {
  // Find subtopics by each layer topic name
  static getSubtopics(topics, layerName = []) {
    if (layerName.length === 0) {
      return topics;
    }
    const layer = layerName.shift();
    return TopicTreeBrowser.getSubtopics(_result(_find(topics, (obj) => (
      obj.topic_name === layer
    )), 'sub_topics'), layerName);
  }

  // check Object has value or not
  static hasValue(obj) {
    if (obj) {
      const values = _values(obj);
      return values.some((value) => value !== '');
    }
    return false;
  }

  constructor(props) {
    super(props);

    // Binding this for actions
    this.clickTopicItem = this.clickTopicItem.bind(this);
    this.clickTopicBack = this.clickTopicBack.bind(this);
    this.clickBackToHome = this.clickBackToHome.bind(this);
  }

  // To get subTopics for TopicList
  getTopicsList() {
    if (this.props.topicSelect.subTopics && this.props.topicSelect.subTopics.length !== 0) {
      return this.props.topicSelect.subTopics;
    } if (TopicTreeBrowser.hasValue(this.props.topicSelect.topics)) {
      // This condition is for data persist
      return this.props.topicSelect.subTopics;
    }
    return this.props.topicTree.topicTreeSelection.sub_topics;
  }

  // To get state for Topic data persist
  getSelectedState(key) {
    const state = this.props.topicSelect;
    if (key && _has(state, key)) {
      return state[key];
    }
    return state;
  }

  getTopicHeading() {
    const layer = this.props.layer;
    const topicName = this.props.topicSelect.topics;

    // Display Header base on the topic layer
    if (this.isReachToSelectResult()) {
      return l10n.getContent('smarthelp/channelSelection.topicSelections.navigation.header.selectResult', { topicName: this.props.selectResult.topicName });
    } if (layer === 2 && topicName.layer1) {
      return l10n.getContent('smarthelp/channelSelection.topicSelections.navigation.header.layer2', { topicName: topicName.layer1 });
    } if (layer === 3 && topicName.layer2) {
      return l10n.getContent('smarthelp/channelSelection.topicSelections.navigation.header.layer3', { topicName: topicName.layer2 });
    }
    return topicLabel.commonIssue;
  }

  // Set Topic tree layer for Click event
  setTopicLayer(item) {
    const key = `layer${item.layer}`;
    const topics = this.getSelectedState('topics');
    topics[key] = item.content.topic_name;

    const topicRef = this.getSelectedState('topicRef');
    topicRef[key] = item.content.ref_id;
  }

  isReachToSelectResult() {
    return !_isEmpty(this.props.selectResult);
  }

  // breadcrumb switch layer logic: layer = `layer${layerNumb}`
  switchLayerLogic(layer) {
    if (layer) {
      const layerNumb = parseInt(layer[layer.length - 1], 10);
      const layerName = [];
      const topics = {
        layer1: '',
        layer2: '',
        layer3: '',
      };
      const topicRef = {
        layer1: '',
        layer2: '',
        layer3: '',
      };
      const stateTopic = this.getSelectedState('topics');
      const stateTopicRef = this.getSelectedState('topicRef');
      // Set topics data with layer and state info
      for (let i = 1; i < layerNumb; i += 1) {
        const key = `layer${i}`;
        topics[key] = stateTopic[key];
        layerName.push(stateTopic[key]);
        topicRef[key] = stateTopicRef[key];
      }

      // Track FPTI for breadcrumb
      const link = 'smarthelp-topics-back';
      trackLink({ id: 'contactUsPage', link: `${link}|${layer}|${stateTopicRef[layer]}` });

      const breadStatus = {
        subTopics: TopicTreeBrowser.getSubtopics(this.props.topicTree.topicTreeSelection.sub_topics, layerName),
        topics,
        topicRef,
        layer: layerNumb,
      };

      // Update global state for data persist
      this.props.selectTopic(breadStatus);
    }
  }

  // Topic List switch layer logic for select topic
  switchSelectTopic(layer, options) {
    switch (layer) {
      case 1:
        this.props.selectTopicL1(options);
        break;
      case 2:
        this.props.selectTopicL2(options);
        break;
      case 3:
        this.props.selectTopicL3(options);
        break;
      default:
        break;
    }
  }

  // making chatbot eligibility false when clicked on back button and BreadCrumb
  chatBotEligibililtyFalse() {
    this.props.postChatBotEligibleFalse();
  }

  // making chatbot eligibility API call when user lands on channel-steering home page
  chatBotEligibiltyAPI() {
    const postChatBotResponse = Page.getChatBotEligibilityParams('contactUSpage', 'GENERIC');
    return this.props.postChatBotEligibility(postChatBotResponse);
  }

  // Handle Topic Tree Browser Click event
  clickTopicItem(item) {
    // Set the topic info for select topic
    this.setTopicLayer(item);

    // Check topic tree reaching to the end
    if (item.content.sub_topics && item.content.sub_topics.length > 0) {
      // Not reach the end of topic tree
      const layer = this.getSelectedState('layer') + 1;
      this.selectTopics(this.getSelectedState('layer'), item, item.content);

      const topicStatus = {
        layer,
        subTopics: item.content.sub_topics,
      };

      // Set global state for data persist
      topicStatus.topics = this.getSelectedState('topics');
      this.props.selectTopic(topicStatus);
      Page.scrollToTop();
    } else {
      // Reach the end of topic tree selection
      this.selectTopics(this.getSelectedState('layer'), item, null);
      this.props.selectTopic(this.getSelectedState());
      Page.scrollToTop();
    }
  }

  // Click handler for Back button
  clickTopicBack() {
    const curtLayer = this.props.layer;
    const isSelectedResult = this.isReachToSelectResult();

    // Using Back button switch to previous layer
    if (isSelectedResult) {
      // Topic tree reach to node leaf and showing upfront faq and back to previous
      this.switchLayerLogic(`layer${curtLayer}`);
    } else if (curtLayer > 1) {
      this.switchLayerLogic(`layer${curtLayer - 1}`);
    }
    this.props.selectTopicReset();
    this.chatBotEligibililtyFalse();
    // when user is on L2 and clicked on backbtn
    if (this.props.topicsDisplay && curtLayer <= 2) {
      this.chatBotEligibiltyAPI();

      // when returning back to default page trigger callus API to check for AM flag to display call option
      if (validateAMFlag()) {
        this.props.fetchPhoneNumber();
      }
    }
  }

  // Back to default topics
  clickBackToHome() {
    this.switchLayerLogic('layer1');
    this.props.selectTopicReset();
    this.chatBotEligibiltyAPI();
  }

  // To handle topic Select, update state and fire request
  selectTopics(layer, item, subTopics) {
    const options = {
      topicId: item.content.topic_id,
      topicName: item.content.topic_name,
      topicRefId: item.content.ref_id,
    };

    if (subTopics) {
      options.subTopic = subTopics;
    } else {
      options.content = item.content;
    }

    this.switchSelectTopic(layer, options);
  }

  // Using back button to replace current breadcrumb
  renderBackButton() {
    // Hide back button in the first lay topic tree
    if (this.props.layer <= 1 && !this.props.selectedIntent) {
      return null;
    } if (this.props.selectedIntent) {
      // Back to home if the user clicked search Intent topics
      return (<NavBackArrow onClick={this.clickBackToHome} />);
    }

    return (<NavBackArrow onClick={this.clickTopicBack} />);
  }

  // Render topic list with topics selection
  renderTopicList() {
    if (!this.props.topicsDisplay) {
      return null;
    }
    return (
      <TopicList
        topicList={this.getTopicsList()}
        onClick={this.clickTopicItem}
        layer={this.getSelectedState('layer')}
      />
    );
  }

  // Render Main header or Header with Search bar
  renderContactHeader() {
    if (!Page.isSearchTopicDisplay()) {
      return <p className="contact-us-header">{topicLabel.contactHeader}</p>;
    }

    // Intent Search tree display control
    if (!this.props.displayIntentSearch) {
      return null;
    }

    return (
      <div className="contact-search-container">
        <ColGrid>
          <p className="contact-us-header">{topicLabel.selectHeader}</p>
          {Page.isLoggedIn() ? <OcpWidget pathName="contactUs" /> : <div />}
          <IntentTopicBox />
        </ColGrid>
      </div>
    );
  }

  // Render Topic tree Header
  renderHeader() {
    return (<h2 className={Page.getSearchTopicClassName('topic-tree-browser-header')}>{this.getTopicHeading()}</h2>);
  }

  renderTopicContent() {
    // Null Check for Topic tree data
    if (!this.props.topicTree.topicTreeSelection) {
      return null;
    }

    return (
      <ColGrid>
        {this.renderHeader()}
        {this.renderBackButton()}
        {this.renderTopicList()}
      </ColGrid>
    );
  }

  // Render Topic Tree Container with Bootstrap Grid System
  renderTopicContainer() {
    return (
      <div className="topic-tree-browser-container">
        {this.renderContactHeader()}
        {this.renderTopicContent()}
      </div>
    );
  }

  render() {
    if (!this.props.display) {
      return null;
    }
    return this.renderTopicContainer();
  }
}

TopicTreeBrowser.propTypes = {
  layer: PropTypes.number.isRequired,
  selectTopicL1: PropTypes.func.isRequired,
  selectTopicL2: PropTypes.func.isRequired,
  selectTopicL3: PropTypes.func.isRequired,
  selectTopicReset: PropTypes.func.isRequired,
  postChatBotEligibleFalse: PropTypes.func.isRequired,
  postChatBotEligibility: PropTypes.func.isRequired,
  selectTopic: PropTypes.func.isRequired,
  topicTree: PropTypes.shape(TOPICTREE).isRequired,
  display: PropTypes.bool.isRequired,
  topicsDisplay: PropTypes.bool.isRequired,
  topicSelect: PropTypes.shape(TOPICSELECT).isRequired,
  selectResult: PropTypes.shape(REF_SELECT_RESULT).isRequired,
  displayIntentSearch: PropTypes.bool.isRequired,
  selectedIntent: PropTypes.bool.isRequired,
  fetchPhoneNumber: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    selectTopicL1, selectTopicL2, selectTopicL3, selectTopicReset, postChatBotEligibility, postChatBotEligibleFalse, selectTopic, fetchPhoneNumber,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    layer: state.topicSelect.layer,
    topicSelect: state.topicSelect,
    topicTree: state.topicTree,
    display: state.topicTree.display,
    topicsDisplay: state.selectResult.topicsDisplay,
    selectResult: state.selectResult.topicTreeSelectResult,
    displayIntentSearch: state.crawlIntentTopic.display,
    selectedIntent: state.crawlIntentTopic.selectedIntent,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TopicTreeBrowser);
